import type { FaireProductEntity } from "../../entity_types/product";

export const p_6qkn45zv72: FaireProductEntity = {
  token: "p_6qkn45zv72",
  type: "product",
  name: "Hand-Carved Pyrite Dog Gemstone Animal Carving",
  brandToken: "b_yv36hmng6n",
  brandName: "Gem Avenue Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/6456d983169932b03cd23b8236a31363c184f115042ee65c0f18e8528fb2fa1d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6853d727c36e1772b86b6cbd4434046706437b201b36a07b335c9f66e23bea1a.jpeg",
    "https://cdn.faire.com/fastly/10488181277e021a858a5202e9460eb8b5f5c9d1c981ea2c4abb9082c70845cb.jpeg",
    "https://cdn.faire.com/fastly/f2534b38fea15c00f0d68b85e071fba1349ef51f6a22875cd1460e59ddcd3c80.jpeg",
    "https://cdn.faire.com/fastly/2675525cb16ef1c75b2e7224acf4b49e32d5a82b51a857801da1c8dc091d57d2.jpeg",
    "https://cdn.faire.com/fastly/f0ba424e714d97d3580f1db29f3b9458d15a231df94dbfc8f3e4bd448ada7593.jpeg",
  ],
  priceDollars: 30.43,
  description:
    "Hand-Carved Pyrite Dog Gemstone Animal Carving is the perfect addition to any retailer's collection. Imported from Peru, these assorted carvings are hand-crafted with the highest quality pyrite gemstone. With wholesale pricing, retailers can make a good profit while offering their customers the best prices.\n",
  tags: [],
  msrpDollars: 60.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:23.026Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
